import { Newsfeed } from "./newsfeed";
import { Participant } from "./participant";
import * as moment from 'moment/moment';

export class NewsfeedReport {
    id: number;
    newsfeed_id: number;
    type: string;
    description: string;
    created_at: string;
    date_created_at: Date;
    participant: Participant = new Participant;

    /**
     * constructor
     *
     * @param {NewsfeedReport} init
     */
    public constructor(init?: NewsfeedReport) {
        if (!!init) {
            Object.assign(this, init);

            this.date_created_at = moment.utc(this.created_at).toDate();

        }
    }

}
